<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
          <template v-slot:status="{ item }">
            <v-chip v-show="item.status === inquiryStatuses.unsolved.value" color="error" text-color="white">
              <v-avatar left><v-icon>mdi-close-circle</v-icon></v-avatar>{{ inquiryStatuses.unsolved.name }}
            </v-chip>
            <v-chip v-show="item.status === inquiryStatuses.hold.value" color="grey" text-color="white">
              <v-avatar left><v-icon>mdi-pencil-circle</v-icon></v-avatar>{{ inquiryStatuses.hold.name }}
            </v-chip>
            <v-chip v-show="item.status === inquiryStatuses.solution.value" color="success" text-color="white">
              <v-avatar left><v-icon>mdi-circle-slice-8</v-icon></v-avatar>{{ inquiryStatuses.solution.name }}
            </v-chip>
          </template>
          <template v-slot:action="{ item }">
            <v-btn class="mr-2" depressed small @click.stop="etsuran(item)" color="success">閲覧</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import CustomDataTable from "@/components/custom_ui/CustomDataTable";
import statusList from "@/helpers/const";
import InquiriesApi from "@/api/inquiries-api";

export default {
  name: "Inquiry",
  components: {
    CustomDataTable,
  },
  props: ["user"],
  data: () => ({
    // 共通コンポーネント: データテーブル関連
    loading: false,
    tableName: "問い合わせ一覧",
    headers: [
      { text: "ステータス", value: "status", sortable: false, align: 'left' },
      { text: "問い合わせ番号", value: "inquiry_number", sortable: true, align: 'left' },
      { text: "タイトル", value: "title", sortable: true, align: 'left' },
      { text: 'アクション', value: 'action', sortable: false, align: 'left'},
    ],
    inquiryStatuses: {
      unsolved: { name: "未解決", value: 0 },
      hold: { name: "保留", value: 1 },
      solution: { name: "解決", value: 2 },
    },
    items: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      this.InquiriesApi = new InquiriesApi();
      const promise = this.InquiriesApi.list();
      promise
        .then(response => {
          this.itemss = response.data.body.inquiries_list;
          for (var item of this.itemss) {
            item.inquiry_number = ( '000000' + item.inquiry_number ).slice( -6 );
            this.items.push(item);
          }
        })
        .catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error", error.response.data.message);
              this.$router.push({ name: "Dashboard" });
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        })
        .finally(() => {
          this.isLoading();
        });
    },
    //閲覧ボタン押下時
    etsuran(item) {
      this.$router.push({
        name: "InquiryInfo",
        params: { id: item.id }
      });
    },
  }
};
</script>
